<kendo-dialog-titlebar>
   {{'admin-center.orderingParty.info' | translate}}
</kendo-dialog-titlebar>

<div fxLayout="column" fxLayoutGap="15px">

    <app-loading-panel [isLoading]="isLoading"></app-loading-panel>

    <div *ngIf="!isLoading && orderingParty" fxLayout="column" fxLayoutGap="10px">
        <div fxLayout="column">
             <strong>{{ orderingParty?.name }}</strong>
            <strong *ngIf="orderingParty.info">{{ 'admin-center.orderingParty.info' | translate }}</strong>
            <span *ngIf="orderingParty.info" [innerHTML]="orderingPartyInfoHtml"></span>
            <span *ngIf="!orderingParty.info" class="error-label">{{ 'admin-center.orderingParty.noInfo' | translate }}</span>
        </div>
    </div>

    <!-- <div fxLayoutAlign="center center" fxLayoutGap="15px">
        <button type="button" kendoButton (click)="close()">{{ 'global.close' | translate }}</button>
    </div> -->
</div>
